import React from 'react';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import cx from 'classnames';

import LocationSearchForm from '../LocationSearchForm';
import VideoSearchForm from '../VideoSearchForm/VideoSearchForm';
import getLocalizedContent from '../../../core/helpers/getLocalizedContent';

import { photosShow } from '../../../helpers/photosShow';
import { homebanneruploadDir } from '../../../config';
import { toWebp } from '../../../helpers/imageHelper';

import carone from './carbanner.jpg';
// Arrow icon replaced with Lucide ChevronDown

import s from './SliderAnimation.css';
import cs from '../../commonStyle.css';

// Module-level flag to prevent re-animation on re-renders
let hasAnimatedOnce = false;

class SliderAnimation extends React.Component {
    static propTypes = {};

    constructor(props) {
        super(props);
        this.scrollTop = this.scrollTop.bind(this);
    }

    componentWillUnmount() {
        // Reset flag when navigating away (optional - remove if you want animation only once per session)
        // hasAnimatedOnce = false;
    }

    handleAnimationComplete = () => {
        hasAnimatedOnce = true;
    }

    scrollTop() {
        window.scrollTo({
            top: screen.height,
            behavior: 'smooth'
        })
    }
    render() {
        const { data: { loading, getBanner }, layoutType, locale } = this.props;
        
        // Get localized content
        const title = getBanner ? getLocalizedContent(getBanner, 'title', locale) : '';
        const content = getBanner ? getLocalizedContent(getBanner, 'content', locale) : '';
        const settings = {
            vertical: true,
            dots: false,
            fade: true,
            infinite: true,
            speed: 6000,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 6000,
            draggable: false,
            touchMove: false,
            pauseOnHover: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        // slidesToShow: 3,
                        // slidesToScroll: 3,
                        infinite: true,
                        dots: false,
                        fade: true,
                        pauseOnHover: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        // slidesToShow: 3,
                        // slidesToScroll: 1,
                        initialSlide: 0,
                        swipe: true,
                        swipeToSlide: true,
                        touchMove: true,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 0,
                        swipe: true,
                        swipeToSlide: true,
                        touchMove: true,
                        centerMode: true


                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 0,
                        swipe: true,
                        swipeToSlide: true,
                        touchMove: true,
                        centerMode: true


                    }
                }
            ]
        };
        let path = photosShow(homebanneruploadDir);

        return (
            <div>
                <div className={cx(s.layoutOneAndThreeHomeBanner)}>
                    <div className={cx(s.layoutOneAndThreeBgSize)}>
                        <div className={cx(s.layoutOneAndThreeBgImg)} style={{ backgroundImage: `url(${path}${getBanner && toWebp(getBanner.image)})` }}>
                        </div>
                        {
                            layoutType && layoutType == 1 &&
                            <div className={s.container}>
                                {
                                    !loading && getBanner &&
                                    <div className={cx(s.layoutOneBannerSection)}>
                                        <motion.div 
                                            className={s.searchbox}
                                            initial={hasAnimatedOnce ? false : { opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.6, ease: 'easeOut' }}
                                        >
                                            <LocationSearchForm />
                                        </motion.div>
                                        <motion.h1 
                                            className={cx(s.noMargin, s.bannerCaptionText)}
                                            initial={hasAnimatedOnce ? false : { opacity: 0, y: 30 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={hasAnimatedOnce ? { duration: 0 } : { delay: 0.3, duration: 0.6, ease: 'easeOut' }}
                                            onAnimationComplete={this.handleAnimationComplete}
                                        >
                                            <span className={s.bannerCaptionHighlight}>{title}</span>
                                            {' '} {content}
                                        </motion.h1>
                                    </div>
                                }
                            </div>
                        }
                        {
                            layoutType && layoutType == 3 &&
                            <div>
                                {
                                    !loading && getBanner &&
                                    <div className={s.container}>
                                        <div className={s.layoutThreeFormContainer}>
                                            <div className={cx(s.layoutThreeFormSection)}>
                                                <h1 className={cx(cs.commonTitleText, cs.fontWeightBold, s.formHeading)}>
                                                    <span>{title}</span>
                                                    {' '} {content}
                                                </h1>
                                                <VideoSearchForm />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }


                        <div className={s.downArrow}>
                            <button 
                                type="button" 
                                className={s.scrollButton} 
                                onClick={this.scrollTop}
                                aria-label="Scroll down"
                            >
                                <ChevronDown size={32} className={s.scrollIcon} />
                            </button>
                        </div>

                    </div>
                </div>
                <div className={cx(s.homeSliderMobile, s.mobileOnly)}>
                    <div className={s.homePosition}>
                        <div className={s.homeCarsoual}>
                            <Slider {...settings}>
                                <div className={s.bgHeight}>
                                    <div className="sliderBg" style={{ backgroundImage: `url(${carone})` }} />
                                </div>


                            </Slider>
                            <div className={s.downArrow}>
                                <div className={s.mobileOnly}>
                                    <img src={arrow} className={s.responsiveImg} onClick={this.scrollTop} alt="scroll down" />
                                </div>
                            </div>
                        </div>
                        {
                            layoutType && layoutType == 1 && <div className={s.gridContainer}>
                                {
                                    !loading && getBanner && <div className={s.sliderContent}>
                                        <h1 className={cx(s.noMargin, s.bannerCaptionText)}>
                                            <span className={s.bannerCaptionHighlight}>{title}</span>
                                            {' '} {content}
                                        </h1>
                                        <div className={s.searchbox}>
                                            <LocationSearchForm />
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        {
                            layoutType && layoutType == 3 && <div className={cx(s.container, s.height100)}>
                                <div className={s.FormBookWrap}>
                                    {
                                        !loading && getBanner && <div className={cx(s.BookWrap, 'BookWrapRTL')}>
                                            <h1><span>{title}</span>
                                                {' '} {content}
                                            </h1>

                                            <VideoSearchForm />
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>

                </div>
            </div>
        );
    }
}

const mapState = (state) => ({
    locale: state.intl.locale
});

export default connect(mapState)(withStyles(s)(SliderAnimation));
